(function () {
  function initStickyAtc() {
    var bars = document.querySelectorAll('.tm-sticky-atc');
    if (!bars.length) return;

    var footer = document.querySelector('.footer');

    bars.forEach(function (bar) {
      var root = bar.closest('main-product') || document;
      var realBtn = root.querySelector('.product__actions button[type="submit"][name="add"]');
      var target = root.querySelector('.product__actions') || root.querySelector('.product__form');

      var pastButtons = false;
      var footerVisible = false;

      function updateVisibility() {
        if (pastButtons && !footerVisible) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }

      if (target && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              pastButtons = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
              updateVisibility();
            });
          },
          { threshold: 0 }
        );
        observer.observe(target);

        if (footer) {
          var footerObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                footerVisible = entry.isIntersecting;
                updateVisibility();
              });
            },
            { threshold: 0 }
          );
          footerObserver.observe(footer);
        }
      }

      var btn = bar.querySelector('[data-tm-sticky-atc-button]');
      if (btn && realBtn) {
        btn.addEventListener('click', function () {
          realBtn.click();
        });
      }
    });
  }

  function initFadeIn() {
    var selectors = '.tm-love-card, .tm-timeline__step, .tm-lifestyle, .tm-section-head, ' +
      '.tm-pmv-card, .tm-diff-card, .tm-journey-step, .tm-audience-card, .tm-contact-card, ' +
      '.tm-brand-story__media, .tm-brand-story__content, .tm-brand-promise__inner, ' +
      '.tm-coll-hero__content';
    var els = document.querySelectorAll(selectors);
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tm-fade-in-visible'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tm-fade-in-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    els.forEach(function (el) {
      el.classList.add('tm-fade-in');
      io.observe(el);
    });
  }

  function init() {
    initStickyAtc();
    initFadeIn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
